import Cookies from "js-cookie";
export const deleteCookies = (name) => {
    Cookies.remove(name, { path: "/" });
    Cookies.remove(name, { path: "/", domain: getCookieRoot() });
};
export function getCookieRoot() {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    if (parts.length < 2)
        return;
    const root = parts.length <= 3 ? parts.slice(-2).join(".") : parts.slice(-3).join(".");
    return "." + root;
}
